import React, { useEffect, useContext, useState } from 'react'

import { getBackendData } from '../../api/api'
import { ThemeContext } from '../../App'
import { SwapVolumeTCVsExternal } from '../../api/interfaces'
import { IChart } from '../../components/Chart/interface'
import LoadingChart from '../../components/LoadingIcon/Loading'
import ChartPage from '../../pages/ChartPage/ChartPage'
import { useChartData } from '../../hooks/useChartData'

async function getCompetitorsSwapVolume(color: string, inverseColor: string, timeframe: string) {
	const chartData = (await getBackendData('thorchain', 'defillama_dex_swap_volumes', timeframe)) as SwapVolumeTCVsExternal[]
	const thorchainData = chartData.filter((row) => row.LABEL === 'thorchain-dex')
	const nearData = chartData.filter((row) => row.LABEL === 'near-intents')
	const chainflipData = chartData.filter((row) => row.LABEL === 'chainflip')

	let series1,
		series2,
		series3: {
			x: number
			y: number
		}[] = []
	series1 = thorchainData.map((element: SwapVolumeTCVsExternal) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.VOLUME }
	})
	series2 = nearData.map((element: SwapVolumeTCVsExternal) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.VOLUME }
	})
	series3 = chainflipData.map((element: SwapVolumeTCVsExternal) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.VOLUME }
	})
	const config: IChart[] = [
		{
			data: series1,
			strokeWidth: 2,
			name: 'THORChain',
			type: 'line',
			seriesGroup: '[% of total]',
			color: 'green',
			unitSymbol: '$'
		},

		{
			data: series2,
			strokeWidth: 2,
			name: 'Near Intents',
			type: 'line',
			seriesGroup: '[% of total]',
			color: 'orange',
			unitSymbol: '$'
		},

		{
			data: series3,
			strokeWidth: 2,
			name: 'Chainflip',
			type: 'line',
			seriesGroup: '[% of total]',
			color: '#e0969b',
			unitSymbol: '$'
		}
	]

	return { config: config, latestValue: series2[series2.length - 1].y, latestValueDate: series2[series2.length - 1].x }
}

const CompetitorsSwapVolume = () => {
	const { dataSeries, timeframe, setTimeframe, isLoading, error, retry } = useChartData(getCompetitorsSwapVolume)

	if (error) {
		return (
			<div style={{ padding: 40, textAlign: 'center' }}>
				<p>Error loading chart: {error}</p>
				<button onClick={retry}>Retry</button>
			</div>
		)
	}

	if (isLoading || dataSeries === undefined) {
		return <LoadingChart />
	}
	return (
		<ChartPage
			chartTitle="Competitors Swap Volume"
			chartDesc={`THORChain’s share of total cross-chain / DEX swap volume relative to competing platforms. Data from Defillama.`}
			chartDescTitle="Metric Description"
			chartData={dataSeries.config}
			queryId="66b87c85-7b06-495b-baca-651d51578068"
			timeframe={timeframe}
			setTimeframe={setTimeframe}
			hasHours={false}
			hasDays={true}
			sortByValueDesc={true}
		/>
	)
}
export default CompetitorsSwapVolume
